module.exports = __webpack_public_path__ + "img/partner8.7d8fc1e1.png";